module.exports = __webpack_public_path__ + "images/logo.f803bb36.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/logo.svg
// module id = 372
// module chunks = 1